/** LocalStorage key: nominated admin has dismissed the welcome intro. */
export const nominatedAdminWelcomeStorageKey = (companyCode: string) =>
  `rv_nominee_welcome_seen_${String(companyCode || "").trim()}`;
